let alerts = $('.alert.flashes, .alert.alert-message')

if (alerts.length) {
    alerts.delay(10000).fadeOut(500)
}
